import styles from "./SearchPage.module.scss";
import classNames from "classnames";
import FontAwesome from "../../components/utilities/FontAwesome";

export function PaginationFooter(props: {
  currentPage: number;
  setPage: (page: number) => void;
  totalPages: number;
  className?: string;
}) {
  const paginationClassName = classNames({
    [styles.blocksFooter]: true,
    [props.className || ""]: props.className,
  });

  return (
    <div className={paginationClassName}>
      <button
        aria-label={"Previous page"}
        disabled={props.currentPage === 1}
        onClick={() => props.setPage(props.currentPage - 1)}
      >
        <FontAwesome key={1} name={"fa-chevron-left"} prefix={"fas"} />
      </button>
      <button
        disabled={props.currentPage === 1}
        onClick={() => props.setPage(1)}
      >
        1
      </button>
      {props.currentPage - 2 > 1 && <span>...</span>}
      {props.currentPage - 1 > 1 && (
        <button onClick={() => props.setPage(props.currentPage - 1)}>
          {props.currentPage - 1}
        </button>
      )}
      {props.currentPage > 1 && props.currentPage < props.totalPages && (
        <button disabled={true}>{props.currentPage}</button>
      )}
      {props.currentPage + 1 < props.totalPages && (
        <button onClick={() => props.setPage(props.currentPage + 1)}>
          {props.currentPage + 1}
        </button>
      )}
      {props.currentPage + 2 < props.totalPages && (
        <button onClick={() => props.setPage(props.currentPage + 2)}>
          {props.currentPage + 2}
        </button>
      )}
      {props.currentPage + 3 < props.totalPages && <span>...</span>}
      {props.totalPages > 1 && (
        <button
          disabled={props.currentPage === props.totalPages}
          onClick={() => props.setPage(props.totalPages)}
        >
          {props.totalPages}
        </button>
      )}
      <button
        aria-label={"Next page"}
        disabled={
          props.currentPage === props.totalPages || props.totalPages === 0
        }
        onClick={() => props.setPage(props.currentPage + 1)}
      >
        <FontAwesome key={2} name={"fa-chevron-right"} prefix={"fas"} />
      </button>
    </div>
  );
}
